import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, Typography, useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';
import { t } from 'i18next';
import { useDispatch } from 'react-redux';
import { MuiIconButton, MuiRightDrawer } from '../../../builderPackage/components';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { MuiBox } from '../../../components';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { setReducerState, setState } from '../../../redux/crudSlice';
import { faintGray } from '../../../theme/palette';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { supplierListAPICall } from '../../spareParts/purchaseRequistion/services/apiCall';
import { ProprietaryWarrantyKeys } from '../services/entity';
import { useAppSelector } from '../../../store/hooks';
import { CrossIcon } from '../../../assets/images';
export var FilterPW = function (props) {
    var _getLocalStorageItem;
    var isFilterOpen = props.isFilterOpen, setFilterOpen = props.setFilterOpen;
    var dispatch = useDispatch();
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var UserParentOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.ParentOrganizationId;
    var filterValue = useAppSelector(function (state) { return state.crud; }).filterValue;
    var handleApplyClick = function (event, values) {
        var _values$FromDate, _values$ToDate, _values$SupplierId;
        var req = {
            FromDate: (_values$FromDate = values === null || values === void 0 ? void 0 : values.FromDate) !== null && _values$FromDate !== void 0 ? _values$FromDate : '',
            ToDate: (_values$ToDate = values === null || values === void 0 ? void 0 : values.ToDate) !== null && _values$ToDate !== void 0 ? _values$ToDate : '',
            SupplierId: (_values$SupplierId = values === null || values === void 0 ? void 0 : values.SupplierId) !== null && _values$SupplierId !== void 0 ? _values$SupplierId : undefined
        };
        dispatch(setState({
            key: "filterValue",
            value: req
        }));
        dispatch(setReducerState({
            key: ProprietaryWarrantyKeys.Paging + 'Updated',
            value: true
        }));
        setFilterOpen(false);
        // event.stopPropagation()
    };
    var getSupplierByParentOrganization = function (param) { return supplierListAPICall(_objectSpread(_objectSpread({}, param), {}, {
        request: {
            ParentOrganizationId: UserParentOrganization
        }
    })); };
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'Header',
            label: '',
            elements: [{
                    type: FormItemTypes.Custom,
                    name: 'Header',
                    label: '',
                    element: function () { /*#__PURE__*/ return React.createElement(MuiBox, null, /*#__PURE__*/ React.createElement(Grid, {
                        container: true,
                        spacing: 5,
                        paddingTop: IS_DESKTOP ? 8 : 0,
                        paddingBottom: 2
                    }, /*#__PURE__*/ React.createElement(Grid, {
                        item: true,
                        xs: 10
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        style: {
                            fontSize: '16px',
                            fontWeight: '600'
                        },
                        color: "black"
                    }, t("Filters"))), /*#__PURE__*/ React.createElement(Grid, {
                        item: true,
                        xs: 2
                    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
                        onClick: function () { return setFilterOpen(false); },
                        style: {
                            justifyContent: 'flex-end'
                        },
                        id: "cancelButton"
                    }, /*#__PURE__*/ React.createElement("img", {
                        id: "crossIconBtn",
                        src: CrossIcon
                    }))))); },
                    value: null,
                    columnSize: 12
                }],
            value: null,
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'FormContainer',
            label: '',
            value: null,
            columnSize: 12,
            sx: {
                marginBottom: '20px',
                flexGrow: 1,
                overflowY: 'auto',
                padding: '16px',
                paddingBottom: 6
            },
            spacing: 3,
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'FilterName',
                    label: '',
                    displayExpr: "Name",
                    placeholder: "Select saved filter",
                    valueExpr: "id",
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'SupplierId',
                    label: 'Vendor',
                    displayExpr: "Name",
                    getListData: getSupplierByParentOrganization,
                    valueExpr: "id",
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'SelectDate',
                    value: null,
                    columnSize: 12,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'SelectDateTypography',
                            label: 'Claim settlement date',
                            value: null,
                            columnSize: 12
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            spacing: 1,
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.DatePicker,
                                    name: 'FromDate',
                                    label: '',
                                    placeholder: "From Date",
                                    value: null,
                                    columnSize: 6,
                                    xs: 12,
                                    sm: 6,
                                    setFormState: function () { return ({
                                        ToDate: null
                                    }); }
                                }, {
                                    type: FormItemTypes.DatePicker,
                                    name: 'ToDate',
                                    label: '',
                                    placeholder: "To Date",
                                    value: null,
                                    columnSize: 6,
                                    xs: 12,
                                    sm: 6,
                                    setFieldProps: function (formValues) {
                                        return {
                                            type: this.type,
                                            minDate: dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.FromDate)
                                        };
                                    }
                                }]
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            label: '',
            value: null,
            spacing: 0,
            sx: {
                bottom: 0,
                justifyContent: 'space-between',
                backgroundColor: 'white',
                width: {
                    xs: '100%',
                    sm: '400px'
                },
                position: 'fixed',
                right: 0,
                zIndex: 1000,
                paddingBottom: '16px',
                borderTop: "1px solid ".concat(faintGray)
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Save Filter',
                    label: '',
                    children: 'Save Filter',
                    value: null,
                    columnSize: 4,
                    disabled: true
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'saveButton',
                    label: '',
                    value: null,
                    columnSize: 8,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'discard',
                            label: '',
                            children: 'Reset Filters',
                            value: null,
                            id: "discard",
                            columnSize: 7,
                            onClick: function () {
                                return 'reset';
                            },
                            variant: 'outlined'
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Apply',
                            label: '',
                            children: 'Apply',
                            value: null,
                            columnSize: 2,
                            variant: 'contained',
                            onClick: handleApplyClick
                        }]
                }],
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(MuiRightDrawer, {
        id: "filter-drawer",
        anchor: "right",
        openDrawer: isFilterOpen,
        onClose: function () { return setFilterOpen(false); },
        sx: {
            width: {
                xs: '100%',
                sm: "400px"
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        formProps: {
            p: 1.5
        },
        getKey: "filterValue",
        mode: "edit"
    }));
};
